module.exports = __webpack_public_path__ + "img/vip-executive-eden-aparthotel.935f8360.jpg";